import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Input,
  Row,
  Col,
  Card,
  Space,
  Empty,
  Divider,
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  FileTextOutlined,
  DollarOutlined,
  ClusterOutlined,
  BarsOutlined,
  GlobalOutlined,
  StockOutlined,
} from "@ant-design/icons";
import { EXPLORE_MODES } from "./constants";
import { DATA, DATA_INDEX } from "../../myanfinviz";
import _, { set } from "lodash";
import { Tabs, Statistic } from "antd";
import { getSearchTerm, getFilteredResults } from "../../utils/searchUtils";
import { RecordDetails } from "./commonUI/RecordDetails";

const { TabPane } = Tabs;
const { Text } = Typography;

export const Individual = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState(DATA);
  const [selected, setSelected] = useState(DATA[0]);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (searchTerm) {
        const improvedSearchTerm = getSearchTerm(searchTerm);
        console.log("Individual improvedSearchTerm", improvedSearchTerm);
        const searchResults = getFilteredResults(
          improvedSearchTerm,
          DATA_INDEX,
          DATA,
          "Company Name In Myanmar"
        );
        console.log("Individual searchResults", searchResults);
        setResults(searchResults);
      }
    }, 700);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm]);

  const onSearch = (e) => {
    console.log("Individual", e.target.value);
    setSearchTerm(e.target.value);
  };

  const renderContent = (selected) => {
    if (selected) {
      return <RecordDetails record={selected} />;
    } else {
      return <Empty />;
    }
  };

  return (
    <div>
      <h3>{EXPLORE_MODES.SEARCH.label}</h3>
      <Row>
        <Col className="individual-left" span={6}>
          <Input
            onChange={onSearch}
            value={searchTerm}
            className="mb-2"
            size="large"
            placeholder="Search"
            prefix={<SearchOutlined />}
          />
          <Space className="results-pane w-100" direction="vertical">
            <p>Results: {`${results.length}`}</p>
            {_.map(results, (record) => {
              return (
                <Card
                  key={`${record["ID"]}`}
                  onClick={() => {
                    setSelected(record);
                  }}
                  className="individual-result-card"
                >
                  <p className="text-primary font-weight-bold">
                    {record["Company Name In Myanmar"]}
                  </p>
                  <p>
                    <small>
                      Total Capital:
                      {record["Total Amount Of Capital (in Millions)"]}
                      {"M MMK"}
                    </small>
                  </p>
                  <p>
                    <small>Type: {record["Type Of Investment Business"]}</small>
                  </p>
                </Card>
              );
            })}
          </Space>
        </Col>
        <Col className="individual-right p-2" span={18}>
          <Tabs
            type="card"
            defaultActiveKey="1"
            size={"large"}
            tabBarExtraContent={
              <Button
                id="copy-json"
                onClick={() => {
                  console.log("individual", selected);
                  navigator.clipboard.writeText(
                    JSON.stringify(selected, null, 2)
                  );
                }}
                icon={<FileTextOutlined />}
              >
                Copy JSON
              </Button>
            }
          >
            <TabPane tab="Details" key="1">
              {renderContent(selected)}
            </TabPane>
            <TabPane tab="Raw JSON" key="2">
              <pre>{JSON.stringify(selected, null, 2)}</pre>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </div>
  );
};
